import React, { useMemo } from "react";
import { motion } from "framer-motion";

export function IntroGrid() {
  return (
    <motion.div
      aria-hidden
      className="absolute inset-0"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.2 }}
      style={{
        backgroundImage:
          "radial-gradient(ellipse at center, rgba(6,182,212,0.16) 0%, rgba(3,6,15,0) 60%), linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)",
        backgroundSize: "100% 100%, 48px 48px, 48px 48px",
        maskImage: "radial-gradient(ellipse at center, black 30%, transparent 75%)",
      }}
    />
  );
}

export function IntroSweep() {
  return (
    <>
      <motion.div
        aria-hidden
        className="absolute top-1/2 left-0 h-[2px] w-full origin-left bg-gradient-to-r from-transparent via-cyan-300 to-transparent shadow-[0_0_24px_6px_rgba(6,182,212,0.6)]"
        initial={{ scaleX: 0, opacity: 1 }}
        animate={{ scaleX: [0, 1, 1], opacity: [1, 1, 0] }}
        transition={{ duration: 0.9, times: [0, 0.6, 1], ease: "easeOut" }}
      />
      {[0, 1, 2].map((i) => (
        <motion.div
          key={i}
          aria-hidden
          className="absolute top-1/2 left-1/2 w-40 h-40 -ml-20 -mt-20 rounded-full border border-cyan-300/60"
          initial={{ scale: 0.2, opacity: 0 }}
          animate={{ scale: 9, opacity: [0, 0.8, 0] }}
          transition={{ delay: 0.35 + i * 0.18, duration: 1.4, ease: "easeOut" }}
        />
      ))}
      <motion.div
        aria-hidden
        className="absolute inset-0 bg-white"
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 0.35, 0] }}
        transition={{ delay: 0.3, duration: 0.35 }}
      />
    </>
  );
}

const DEFAULT_PARTICLE_COLORS = ["#10b981", "#06b6d4", "#60a5fa"];
export function IntroParticles({ count = 36, colors = DEFAULT_PARTICLE_COLORS }) {
  const parts = useMemo(
    () => Array.from({ length: count }, (_, i) => {
      const a = (i / count) * Math.PI * 2 + Math.random() * 0.3;
      const d = 260 + Math.random() * 520;
      return { x: Math.cos(a) * d, y: Math.sin(a) * d, s: 2 + Math.random() * 4, c: colors[i % colors.length], delay: 0.3 + Math.random() * 0.25 };
    }),
    [count, colors]
  );
  return (
    <div aria-hidden className="absolute top-1/2 left-1/2">
      {parts.map((p, i) => (
        <motion.span
          key={i}
          className="absolute rounded-full"
          style={{ width: p.s, height: p.s, background: p.c, boxShadow: `0 0 ${p.s * 3}px ${p.c}` }}
          initial={{ x: 0, y: 0, opacity: 0 }}
          animate={{ x: p.x, y: p.y, opacity: [0, 1, 0] }}
          transition={{ delay: p.delay, duration: 1.8, ease: [0.1, 0.8, 0.3, 1] }}
        />
      ))}
    </div>
  );
}
